var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "function-card" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { type: "button" },
          on: { click: _vm.addTemplate },
        },
        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Create")) + " ")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c(
          "VueBootstrap4Table",
          {
            attrs: {
              rows: _vm.rows,
              columns: _vm.columns,
              config: _vm.config,
              "total-rows": _vm.totalData,
            },
            on: { "on-change-query": _vm.changePage },
            scopedSlots: _vm._u([
              {
                key: "CreateTime",
                fn: function (props) {
                  return [
                    _c("div", [
                      props.row.CreateTime
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$common.dateTimeFormatter(
                                    props.row.CreateTime
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "UpdateTime",
                fn: function (props) {
                  return [
                    _c("div", [
                      props.row.UpdateTime
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$common.dateTimeFormatter(
                                    props.row.UpdateTime
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "copy",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.copyTemplate(props.row.MailTemplateGuid)
                          },
                        },
                      },
                      [_vm._v(" 複製 ")]
                    ),
                  ]
                },
              },
              {
                key: "edit",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.editTemplate(props.row)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "delete",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#deleteModal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.deleteItem = props.row
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [_c("template", { slot: "empty-results" }, [_vm._v(" 暫無資料 ")])],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "deleteModal", tabindex: "-1", "data-backdrop": "static" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("span", [_vm._v(_vm._s(_vm.i18n("Template.DeleteTemplate")))]),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _vm._v(" 確認刪除"),
              _c(
                "span",
                { staticStyle: { "font-weight": "bolder", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.deleteItem.MailTemplateName))]
              ),
              _vm._v(" ? "),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button", "data-dismiss": "modal" },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.delMailTemplate },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }